const formatDollarPrice = (priceInDollars: number, fractionDigits: number) => {
  const numberFormat = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
  const formattedPrice = numberFormat.format(priceInDollars);

  return `${formattedPrice}`;
};
const centsToDollars = (priceInCents: number) => {
  const dollars = priceInCents / 100;
  return Math.round(dollars * 100) / 100;
};

// TODO use formatMinorUnits from currency package
// formatMinorUnits(priceInCents, { currency: 'USD', locale: 'en-US'})
const formatPriceWithCents = (priceInCents: number) =>
  formatDollarPrice(centsToDollars(priceInCents), 2);

export { centsToDollars, formatPriceWithCents };
